<section id="landing-page" class="content kyloe-watermark">
  <button theme="landing-page-large" id="datacleaner-btn"
          (click)="goToApp(DataToolsApps.DATA_CLEANER)"
          [disabled]="(dataCleanerChecking$ | async) || appDisabled(DataToolsApps.DATA_CLEANER)"
          [matTooltip]="appDisabled(DataToolsApps.DATA_CLEANER) ? 'Please contact your Administrator to enable ' + DataToolsAppsTitles.DATA_CLEANER : ''"
          matTooltipShowDelay="500"
          appRipple>
    <div *ngIf="dataCleanerChecking$ | async; else datacleanerIcon" class="card-spinner-wrapper">
      <span class="card-spinner"></span>
    </div>
    <ng-template #datacleanerIcon><i class="DataCleaner-KyloeIcon"></i></ng-template>
    <div class="app-desc">
      <h2 class="app-title red">DataCleaner</h2>
      <p>Identify and improve incomplete and outdated records</p>
      <p class="red disabled-message" *ngIf="dataCleanerChecking$ | async; else datacleanerDisabled">Authenticating...</p>
      <ng-template #datacleanerDisabled><p class="red disabled-message">Please contact your Administrator to enable</p></ng-template>
    </div>
  </button>

  <button theme="landing-page-large" id="duplikit-btn"
          (click)="goToApp(DataToolsApps.DUPLIKIT)"
          [disabled]="(duplikitChecking$ | async) || appDisabled(DataToolsApps.DUPLIKIT)"
          [matTooltip]="appDisabled(DataToolsApps.DUPLIKIT) ? 'Please contact your Administrator to enable ' + DataToolsAppsTitles.DUPLIKIT : ''"
          matTooltipShowDelay="500"
          appRipple>
    <div *ngIf="duplikitChecking$ | async; else duplikitIcon" class="card-spinner-wrapper">
      <span class="card-spinner"></span>
    </div>
    <ng-template #duplikitIcon><i class="DupliKit-KyloeIcon"></i></ng-template>
    <div class="app-desc">
      <h2 class="app-title red">DupliKit</h2>
      <p>Detect and merge duplicate Bullhorn records with confidence</p>
      <p class="red disabled-message" *ngIf="duplikitChecking$ | async; else duplikitDisabled">Authenticating...</p>
      <ng-template #duplikitDisabled><p class="red disabled-message">Please contact your Administrator to enable</p></ng-template>
    </div>
  </button>

  <button theme="landing-page-large" id="datarules-btn"
          (click)="goToApp(DataToolsApps.DATARULES)"
          [disabled]="(dataRulesChecking$ | async) || appDisabled(DataToolsApps.DATARULES)"
          [matTooltip]="appDisabled(DataToolsApps.DATARULES) ? 'Please contact your Administrator to enable ' + DataToolsAppsTitles.DATARULES : ''"
          matTooltipShowDelay="500"
          appRipple>
    <div *ngIf="dataRulesChecking$ | async; else datarulesIcon" class="card-spinner-wrapper">
      <span class="card-spinner"></span>
    </div>
    <ng-template #datarulesIcon><i class="DataRules-KyloeIcon"></i></ng-template>
    <div class="app-desc">
      <h2 class="app-title red">DataRules</h2>
      <p>Use bulk data updates to dramatically improve data quality</p>
      <p class="red disabled-message" *ngIf="dataRulesChecking$ | async; else datarulesDisabled">Authenticating...</p>
      <ng-template #datarulesDisabled><p class="red disabled-message">Please contact your Administrator to enable</p></ng-template>
    </div>
  </button>
</section>
